import { useEffect } from "react";
import { getSeoData } from '../store/slices/seoSlice';
import { useDispatch } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { useSelector } from "react-redux";

export const useSeo = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  let path = location.pathname;
  let page = path;
  let type = "page";
  const urlParams = useParams();

  const seoData = useSelector((state) => state.seo);

  useEffect(() => {

    if (path == "/") {
      page = "home";
    }

    if (urlParams?.retreatId) {
      type = 'retreat';
    }

    if (location.pathname.includes('/program/')) {
      type = "programs";
    }

    if (location.pathname.includes('/prayer/')) {
      type = "prayer";
    }


    dispatch(getSeoData({ page, type }));
  }, []);
};
